import dialogueForm from '../modules/form-dialogue'

window.addEventListener('load', event => {
  new dialogueForm();
})
